 

// src/app/store.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/AuthSlice'; 
import cartReducer from './slices/CartSlice';
import settingsReducer from './slices/SettingsSlice';
import adminUsersReducer from './slices/Admin/UsersSlice'; 
import addressesReducer from './slices/Customer/AddressesSlice';
import ordersReducer from './slices/Customer/OrdersSlice';
import commonReducer from './slices/CommonSlice';
const store = configureStore({
    reducer: {
        adminUsers: adminUsersReducer,
        auth: authReducer,
        customerOrders: ordersReducer,
        customerAddresses: addressesReducer,
        cart: cartReducer,
        settings: settingsReducer,
        common:  commonReducer
        //advanceTable: advanceTableReducer
    }
});


export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;


